import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import searchFilter from '../../searchFilter';
import {useLazyLoadQuery} from 'react-relay/hooks';
import Wallet01Svg from '../../assets/icons0/wallet-01.svg';
import Building02Svg from '../../assets/icons0/building-02.svg';
import LogOut04Svg from '../../assets/icons0/log-out-04.svg';
import {graphqlWhoamiNextQuery} from '../graphql';
import classNames from 'classnames';
import {STEM_OFFSET} from '../../constants';
import InfoCircle01Icon from '../../assets/icons0/info-circle-01.svg';
import Currency from '../currency/currency';
import Apply from '../Apply';
import {ErrorBoundary} from 'react-error-boundary';

const StemBalanceUserMenu = React.memo(() => {
    const {whoamiNext} = useLazyLoadQuery(graphqlWhoamiNextQuery);
    const balance = whoamiNext?.balance ? whoamiNext.balance / STEM_OFFSET || 0 : 0;
    return (
        <div className='display-flex flex-1 align-items-center padding-top-0dot25rem'>
            <p className='text-sm color-gray-700 display-flex align-items-center'>
                <FormattedMessage defaultMessage='Accumulated'/>:
                <span className='color-gray-500 padding-right-0dot125rem'> {balance}</span>
                <Currency {...{isStem: true, stemIconClasses: 'display-block width-1rem height-1rem'}}/>
            </p>
            <Link className='padding-left-0dot5rem'>
                <InfoCircle01Icon className='display-block width-1rem height-1rem'/>
            </Link>
        </div>
    )
});

const UserMenu = ({userMenuRef, userMenuFlag, toggleUserMenu}) => {
    const location = useLocation();
    const {whoamiNext} = useLazyLoadQuery(graphqlWhoamiNextQuery);
    
    return (
        <div
            ref={userMenuRef}
            className={classNames('display-none', {'display-block': userMenuFlag})}
        >
            {whoamiNext &&
                <div className='view'>
                    <div className='block'>
                        <div className='position-relative'>
                            <div className='position-absolute background-color-white border-1px-solid-black border-top-color-gray-200 border-bottom-color-gray-200 border-left-color-gray-200 border-right-color-gray-200 border-radius-0dot5rem z-index-1' style={{top: -12, right: 0}}>
                                <div className='display-flex flex-direction-column padding-left-1dot5rem padding-right-1dot5rem padding-top-0dot875rem padding-bottom-0dot875rem'>
                                    <div className='text-md color-gray-700'>
                                        {whoamiNext.username || whoamiNext.email}
                                    </div>
                                    <Apply {...{on: 'stem'}}>
                                        <ErrorBoundary>
                                            <React.Suspense fallback={<div/>}>
                                            <StemBalanceUserMenu/>
                                            </React.Suspense>
                                        </ErrorBoundary>
                                    </Apply>
                                </div>
                                <div className='height-0dot0625rem background-color-gray-100'/>
                                <div className='padding-top-0dot25rem padding-right-1dot5rem'>
                                    <Link to={`/wallet${searchFilter(location.search)}`} onClick={toggleUserMenu}>
                                        <div className='display-flex align-items-center padding-left-1dot5rem height-2dot5rem'>
                                            <Wallet01Svg className='display-block height-1dot5rem width-1dot5rem color-gray-600'/>
                                            <div className='padding-left-0dot75rem text-md medium color-gray-900'>
                                                <FormattedMessage defaultMessage='Wallet'/>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className='padding-top-0dot25rem padding-right-1dot5rem'>
                                    <Link to={`/business${searchFilter(location.search)}`} onClick={toggleUserMenu}>
                                        <div className='display-flex align-items-center padding-left-1dot5rem height-2dot5rem'>
                                            <Building02Svg className='display-block height-1dot5rem width-1dot5rem color-gray-600'/>
                                            <div className='padding-left-0dot75rem text-md medium color-gray-900'>
                                                <FormattedMessage defaultMessage='Business cabinet'/>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                                <div className='padding-top-0dot25rem padding-right-1dot5rem'>
                                    <div className='opacity-0dot4 display-flex align-items-center padding-left-1dot5rem height-2dot5rem'>
                                        <Building02Svg className='display-block height-1dot5rem width-1dot5rem color-gray-600'/>
                                        <div className='padding-left-0dot75rem text-md medium color-gray-900'>
                                            <FormattedMessage defaultMessage='Account'/>
                                        </div>
                                    </div>
                                </div>
                                <div className='padding-top-0dot25rem'>
                                    <div className='height-0dot0625rem background-color-gray-100'/>
                                </div>
                                <div className='padding-top-0dot25rem padding-right-1dot5rem'>
                                    <Link to={`/log-out${searchFilter(location.search)}`} onClick={toggleUserMenu}>
                                        <div className='display-flex padding-left-1dot5rem height-2dot75rem padding-top-0dot5rem'>
                                            <LogOut04Svg className='display-block height-1dot5rem width-1dot5rem color-gray-500'/>
                                            <div className='padding-left-0dot75rem text-md medium color-gray-500'>
                                                <FormattedMessage defaultMessage='Log out'/>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
};

export default React.memo(UserMenu);